import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { useMeasure } from 'react-use';
import { Alert } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import { compose } from 'redux';
import { EMBEDDED } from 'containers/App/constants';
import withRoutes from 'containers/Routes/withEntity';
import withSettings from 'containers/SettingsProvider/withSettings';
import withUser from 'containers/User/withUser';
import ElevationControl from './ElevationControl';
import { ELEVATION_HEIGHT } from '../Map/constants';
import getPath from './getPath';
import Chart from './Chart';
import { useElevation } from './ElevationProvider';
import messages from './messages';

const Wrapper = styled.div`
  position: absolute;
  bottom: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  & > button {
    z-index: 1000;
  }
  #elevation-chart {
    height: ${ELEVATION_HEIGHT}px;
    flex-grow: 1;
    width: 100%;
    position: relative;
  }
  .elevation-alert {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    max-width: 480px;
    margin: 0 auto;
    padding: 1rem;
  }
`;

function ElevationChart(props) {
  const { currentRoute, workingRoute, location, user } = props;
  const [path, setPath] = useState(null);
  const { showElevation, setShowElevation } = useElevation();
  const [ref, { width }] = useMeasure();

  const toggleShowControl = () => setShowElevation(!showElevation);

  async function updatePath() {
    const p = await getPath(workingRoute, currentRoute, location);
    if (p !== undefined) {
      setPath(p);
    }
  }

  useEffect(
    () => {
      if (showElevation) {
        updatePath();
      }
    },
    [showElevation, currentRoute, workingRoute, location.pathname],
  );

  if (EMBEDDED) {
    return null;
  }
  return (
    <Wrapper
      id="elevation-wrapper"
      height={showElevation ? ELEVATION_HEIGHT : 0}
    >
      <ElevationControl onChange={toggleShowControl} />
      {showElevation && (
        <div id="elevation-chart" ref={ref}>
          {user && user.pm ? (
            <Chart points={path} width={width} height={ELEVATION_HEIGHT} />
          ) : (
            <div className="elevation-alert">
              <Alert className="text-center">
                <div className="mb-4">
                  <FormattedMessage {...messages.supportersOnly} />
                </div>
                <a href="#subscription" className="btn btn-primary">
                  <FormattedMessage {...messages.supporterButton} />
                </a>
              </Alert>
            </div>
          )}
        </div>
      )}
    </Wrapper>
  );
}

ElevationChart.propTypes = {
  currentRoute: PropTypes.object,
  workingRoute: PropTypes.object,
  location: PropTypes.object,
  user: PropTypes.object,
};

export default compose(
  withSettings(['units']),
  withRoutes,
  withUser,
)(ElevationChart);
